export default __webpack_public_path__ + "static/media/snow-C2.9eed89da.png";